import { createContext } from 'react';
import {
  DEFAULT_THEME,
  DEFAULT_THEME_PREFERENCE,
  tTheme,
  tThemePreference
} from './themeConfig';

export interface IColorThemeContext {
  /** The palette showing now: `preference`, with `system` resolved against the device. */
  theme: tTheme;
  /** What the student picked. */
  preference: tThemePreference;
  switchTheme: (preference: tThemePreference) => void;
}

export const ColorThemeContext = createContext<IColorThemeContext>({
  theme: DEFAULT_THEME,
  preference: DEFAULT_THEME_PREFERENCE,
  switchTheme: () => undefined
});
